// frontend/src/utils/constants.js

/**
 * Friendly names for membership types
 */
export const MEMBERSHIP_FRIENDLY_NAMES = {
  "IMP-SAUN-MON-001": "Imperial Sauna Membership",
  "IMP-SAUN-3M-001": "Imperial Sauna Membership",
  "IMP-SAUN-6M-001": "Imperial Sauna Membership",
  "IMP-SAUN-YR-001": "Imperial Sauna Membership",
  "PRE-SAUN-MON-002": "Prestige Sauna Membership",
  "PRE-SAUN-3M-002": "Prestige Sauna Membership",
  "PRE-SAUN-6M-002": "Prestige Sauna Membership",
  "PRE-SAUN-YR-002": "Prestige Sauna Membership",
  "SIG-SAUN-MON-003": "Signature Sauna Membership",
  "SIG-SAUN-3M-003": "Signature Sauna Membership",
  "SIG-SAUN-6M-003": "Signature Sauna Membership",
  "SIG-SAUN-YR-003": "Signature Sauna Membership",
  "ETR-RL-MON-005": "Etrnl Radiance Red Light Membership",
  "ETR-RL-3M-005": "Etrnl Radiance Red Light Membership",
  "ETR-RL-6M-005": "Etrnl Radiance Red Light Membership",
  "ETR-RL-YR-005": "Etrnl Radiance Red Light Membership",
  "DAIM-SRL-MON-012": "Diviti Adora Infinite Membership",
  "DAIM-SRL-3M-012": "Diviti Adora Infinite Membership",
  "DAIM-SRL-6M-012": "Diviti Adora Infinite Membership",
  "DAIM-SRL-YR-012": "Diviti Adora Infinite Membership",
  none: "No Active Membership",
};

/**
 * Friendly names for package types
 */
export const PACKAGE_FRIENDLY_NAMES = {
  "GSE-SAUN-007": "Grand Sauna Ensemble Package",
  "PSA-SAUN-008": "Platinum Sauna Package",
  "ESC-SAUN-009": "Essence Sauna Package",
  "LEP-RL-010": "Luminescent Elite Package",
  "REP-RL-011": "Radiant Essentials Package",
  none: "No Active Package",
};

/**
 * Get operating hours based on day of week
 * @param {moment} m - Moment.js date object
 * @returns {Object} - Object with startHour and endHour
 */
export const getOperatingHours = (m) => {
  const day = m.day();
  return day === 0 || day === 6
    ? { startHour: 7, endHour: 20 } // Weekend hours
    : { startHour: 7, endHour: 21 }; // Weekday hours
};
